import { useReducer } from 'react'

export default function useRftQueries() {
  const paginatorStorageKey = Object.keys(localStorage).find((key) => key.includes('RftPaginator'))
  let pageCount = 10
  if (paginatorStorageKey) {
    pageCount = Number(localStorage.getItem(paginatorStorageKey))
  }
  const initialState = {
    functions: null,
    functionNames: [],
    selectedOption: null,
    params: {},
    resultsList: null,
    showSubmit: false,
    showAll: false,
    oldestToNewest: false,
    newIds: [],
    namesMap: {},
    page: 0,
    pageCount,
    totalElements: 0,
  }

  const checkNoResults = (result) => {
    if (result.runStatus === 'Successful' && result.recordCount === 0) {
      result.runStatus = 'No Results'
    }
    return result
  }

  const setResultsList = (state, action, ids) => {
    if (!action.value?.content) {
      action.value = { content: [] }
    }
    action.value?.content?.map(async (result) => {
      result = checkNoResults(result)
      if (!state.namesMap[result.requesterCisId]) {
        ids.add(result.requesterCisId)
      }
      return result
    })
  }

  const reducer = (state, action) => {
    switch (action.type) {
      case 'SET_FUNCTION_OPTION':
        return { ...state, selectedOption: action.value, params: {} }
      case 'SET_FUNCTIONS':
        return { ...state, functions: action.functions, functionNames: action.functionNames }
      case 'SET_PARAMS':
        return { ...state, params: { ...state.params, [action.paramName]: action.value } }
      case 'SET_RESULTS_LIST': {
        const ids = new Set()
        setResultsList(state, action, ids)
        return { ...state, resultsList: action.value.content, totalElements: action.value.totalElements, newIds: ids }
      }
      case 'UPDATE_JOB_STATUS': {
        action.value = checkNoResults(action.value)
        const updatedResults = [...state.resultsList]
        const index = state.resultsList.findIndex((entry) => entry.jobId === action.jobId)
        updatedResults[index] = action.value
        return { ...state, resultsList: updatedResults }
      }
      case 'DELETE_JOB':
        return { ...state, resultsList: state.resultsList.filter((result) => result.jobId !== action.value) }
      case 'TOGGLE_SHOW_ALL':
        return { ...state, showAll: action.value }
      case 'TOGGLE_OLDEST':
        return { ...state, oldestToNewest: action.value }
      case 'TOGGLE_SHOW_SUBMIT':
        return { ...state, showSubmit: !state.showSubmit, selectedOption: null, params: {} }
      case 'SET_NAMES_MAP': {
        const result = {}
        Object.assign(result, state.namesMap, action.value)
        return { ...state, namesMap: result }
      }
      case 'SET_PAGE':
        return { ...state, page: action.value }
      case 'SET_PAGE_COUNT':
        return { ...state, pageCount: action.value }
      case 'REFRESH_AFTER_SUBMIT': {
        const ids = new Set()
        setResultsList(state, action, ids)
        return {
          ...state,
          resultsList: action.value.content,
          totalElements: action.value.totalElements,
          newIds: ids,
          page: action.page,
        }
      }
      default:
        return state
    }
  }
  const [state, dispatch] = useReducer(reducer, initialState)

  return { state, dispatch }
}
